module.exports = __webpack_public_path__ + "static/media/ai.429f0247.svg";